








import { IEntity } from '@/typings/import';
import { Component, Prop, Vue } from "vue-property-decorator";
import PropertyUpdateRow from '@/components/Importer/PropertyUpdateRow.vue';
@Component({
  components: {
    PropertyUpdateRow,
  },
})
export default class PropertyUpdateTable extends Vue {
   pagination = {
    page: 1,
    rowsPerPage: -1, // -1 for All
    sortBy: 'name',
  };

  @Prop({ required: true }) entity: IEntity<any>;

  get headers() {
    return [
      { value: 'propertyName', text: 'Kentän nimi' },
      { value: 'oldValue', text: 'Vanha arvo' },
      { value: 'newValue', text: 'Uusi arvo' },
      { value: 'doNotUpdate', text: 'Älä päivitä' },
      { value: 'overrideValue', text: 'Ohitusarvo' },
    ];
  }
}
